export default {
  title: 'Alennuskoodi',
  fields: {
    preset: {
      label: 'Esiasetus',
    },
    presets: {
      master: 'Pää',
      campaign: 'Kampanja',
      one_time: 'Kertakäyttöinen',
    },
    code: {
      label: 'Koodi',
      placeholder: 'Anna koodi',
    },
    discount_type: {
      label: 'Alennustyyppi',
    },
    quantity: {
      label: 'Määrä',
      placeholder: 'Rajaton',
    },
    expires_at: {
      label: 'Voimassaolon päättymispäivä',
      placeholder: 'Anna päivämäärä tai jätä tyhjäksi',
    },
    franchise: {
      label: 'Ravintolan ja/tai koko brändin pääalennuskoodi',
    },
    discount: {
      label: 'Alennus',
    },
    usage_threshold: {
      label: 'Käyttökynnys',
    },
  },
  messages: {
    master_warning: 'Uuden "pää"-alennuskoodin luominen vanhentaa nykyisen pääalennuskoodin',
  },
  buttons: {
    save: 'Tallenna',
    cancel: 'Peruuta',
  },
  toasts: {
    promo_code_got_created: 'Alennuskoodi luotiin',
    promo_code_got_updated: 'Alennuskoodi päivitettiin',
  },
};
